import { client } from '@/services/authClient';

// --- Favorite Collections ---
export const getFavoriteCollections = () =>
  client.get('/me/favorite-collections/').then((r) => r.data);

export const createFavoriteCollection = (name, color = null, icon = null, order = 0) =>
  client.post('/me/favorite-collections/', { name, color, icon, order }).then((r) => r.data);

export const getFavoriteCollection = (pk) =>
  client.get(`/me/favorite-collections/${pk}/`).then((r) => r.data);

export const updateFavoriteCollection = (pk, patch) =>
  client.patch(`/me/favorite-collections/${pk}/`, patch).then((r) => r.data);

export const deleteFavoriteCollection = (pk) =>
  client.delete(`/me/favorite-collections/${pk}/`).then((r) => r.data);

export const addFavoriteItem = (pk, mls_number) =>
  client.post(`/me/favorite-collections/${pk}/items/`, { mls_number }).then((r) => r.data);

export const removeFavoriteItem = (pk, mls) =>
  client.delete(`/me/favorite-collections/${pk}/items/${mls}/`).then((r) => r.data);

// --- Saved Searches ---
export const getSavedSearches = () =>
  client.get('/me/saved-searches/').then((r) => r.data);

export const createSavedSearch = (name, filters) =>
  client.post('/me/saved-searches/', { name, filters }).then((r) => r.data);

export const deleteSavedSearch = (tmplId) =>
  client.delete(`/me/saved-searches/${tmplId}/`).then((r) => r.data);

// --- Alerts ---
export const getAlerts = () =>
  client.get('/me/alerts/').then((r) => r.data);

export const createAlert = (payload) =>
  client.post('/me/alerts/', payload).then((r) => r.data);

export const updateAlert = (pk, payload) =>
  client.patch(`/me/alerts/${pk}/`, payload).then((r) => r.data);

export const deleteAlert = (pk) =>
  client.delete(`/me/alerts/${pk}/`).then((r) => r.data);

// --- Notifications ---
export const getNotifications = () =>
  client.get('/me/notifications/').then((r) => r.data);

export const markNotificationRead = (pk) =>
  client.post(`/me/notifications/${pk}/read/`).then((r) => r.data);

export const getNotificationPreferences = () =>
  client.get('/me/notification-preferences/').then((r) => r.data);

export const updateNotificationPreferences = (prefs) =>
  client.put('/me/notification-preferences/', prefs).then((r) => r.data);

// --- Conversations / Messages ---
export const getConversations = () =>
  client.get('/me/conversations/').then((r) => r.data);

export const getMessages = (convId) =>
  client.get(`/me/conversations/${convId}/messages/`).then((r) => r.data);

export const sendMessage = (convId, body) =>
  client.post(`/me/conversations/${convId}/messages/`, { body }).then((r) => r.data);

// --- Packages / Billing ---
export const getPackages = () =>
  client.get('/packages/').then((r) => r.data);

export const createCheckoutSession = (package_id, billing_cycle = 'monthly') =>
  client.post('/me/checkout-session/', { package_id, billing_cycle }).then((r) => r.data);

export const getSubscription = () =>
  client.get('/me/subscription/').then((r) => r.data);

export const openBillingPortal = () =>
  client.post('/me/billing-portal/').then((r) => r.data);
